<template>
  <v-container>
    <v-row no-gutters justify="space-between" class="mb-1">
      <v-btn
        v-if="getIsAdmin"
        text
        color="success"
        @click="createNewPreparationSlipTemplate"
      >
        <v-icon small left>fa-plus</v-icon>
        Nouveau Gabarit
      </v-btn>
      <DefaultDailyPrepSlipEditor
        v-if="getIsAdmin && !$vuetify.breakpoint.xsOnly"
      ></DefaultDailyPrepSlipEditor>
      <v-menu
        ref="menu"
        v-model="menu"
        offset-y
        v-if="$vuetify.breakpoint.xsOnly"
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon text v-on="on">
            <v-icon v-if="menu === true">far fa-caret-square-up</v-icon>
            <v-icon v-else>far fa-caret-square-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <DefaultDailyPrepSlipEditor list></DefaultDailyPrepSlipEditor>
        </v-list>
      </v-menu>
    </v-row>
    <v-card>
      <v-card-text>
        <PreparationSlipTemplateGrid
          :loading="loading"
        ></PreparationSlipTemplateGrid>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {
  PreparationSlipTemplateGrid,
  DefaultDailyPrepSlipEditor
} from "../components";
import { mapGetters } from "vuex";
export default {
  name: "PreparationSlipTemplateIndex",
  components: {
    PreparationSlipTemplateGrid,
    DefaultDailyPrepSlipEditor
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.getData();
    });
  },
  async beforeRouteUpdate() {
    await this.getData();
  },
  computed: {
    ...mapGetters(["getIsAdmin", "getStoreId"])
  },
  data() {
    return {
      loading: false,
      menu: false
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        await Promise.all([
          this.$store.dispatch("loadDefaultDailySetting"),
          this.$store.dispatch("loadPreparationSlips", {
            store: this.getStoreId
          }),
          this.$store.dispatch("loadPreparationSlipTemplates", {
            store: this.getStoreId
          })
        ]);
      } finally {
        this.loading = false;
      }
    },
    createNewPreparationSlipTemplate() {
      this.$router.push({ name: "PreparationSlipTemplateEditor" });
    }
  },
  watch: {
    getStoreId() {
      this.getData();
    }
  }
};
</script>

<style></style>
